__turbopack_context__.v({
  "footer": "Footer-module__6EAZGW__footer",
});
